import type { VFC } from 'react'
import { Link } from '@opallabs/lapidary'
import { SsoStatus } from '../../types'
import type { SsoLinkProps } from './types'

export const SsoLink: VFC<SsoLinkProps> = ({
  companyName,
  ssoIdpName,
  ssoStatus,
  ssoUrl,
  theme = 'light',
}) => {
  if (ssoStatus === SsoStatus.Disabled) return null
  if (ssoUrl === '') return null

  // @note The trailing space here is important.
  let connectionLabel = 'Connect your '
  if (ssoIdpName) connectionLabel += ssoIdpName
  else if (companyName) connectionLabel += `${companyName} ID`
  else connectionLabel += 'account'

  return (
    <p>
      Using SSO?&nbsp;
      <Link href={ssoUrl} theme={theme}>
        {connectionLabel}
      </Link>
      .
    </p>
  )
}
SsoLink.displayName = 'ExAstra: SsoLink ← Form ← AccountCreation'
